// ============================================================================
// DEPARTURE ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Departure';

export const departureEndpoints = {
  /** GET /api/v1/Departure/preview/{bookingId} — rooms + gate state for the picker. */
  preview: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/preview/:bookingId`, { bookingId }),
  /** POST /api/v1/Departure/{bookingId}/rooms — departs the selected rooms. */
  departRooms: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/rooms`, { bookingId }),
  /** POST /api/v1/Departure/{bookingId}/stay-charges/preview — early / late / overstay / retention (slice 7c-2). */
  stayChargesPreview: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/stay-charges/preview`, { bookingId }),
} as const;

export default departureEndpoints;
